module.exports = __webpack_public_path__ + "static/media/cloudy.9980731f.svg";